import { render } from "./RubricRowItem.vue?vue&type=template&id=2fb0561c"
import script from "./RubricRowItem.vue?vue&type=script&lang=js"
export * from "./RubricRowItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__